export const generalTaskPathname = 'general-task';
